export function getAccountId(appDefId: string, appInstanceId: string): string {
  return `${appDefId}:${appInstanceId}`;
}
